
import Cars from "./images/cars.svg";
import BannerDealer from "./images/banner-dealer.svg";

export const SELL_TO_OPTIONS = {
    CARS24: "CARS24",
    OFFLINE: "OFFLINE"
};

export const DIY_OFFLINE_LANDING_OBJECTS = [
    {
        id: SELL_TO_OPTIONS.CARS24,
        heading: "Sell via CARS24",
        description: "Set a price at which you would like to sell your car to CARS24",
        footer: "",
        c24assurred: true,
        details: [
            {
                label: "Quicker sell"
            },
            {
                label: "Seller protection policy"
            },
            {
                label: "Safe payment only through bank transfers"
            },
            {
                label: "Easy doorstep pickup"
            }
        ],
        image: Cars
    },
    {
        id: SELL_TO_OPTIONS.OFFLINE,
        heading: "Cash transaction with Dealer",
        description: "We will share your car price with our dealer network and connect you with an interested dealer.",
        footer: "This sale is directly between the seller and the dealer. CARS24 is not responsible for any terms and agreements of this deal.",
        c24assurred: false,
        details: [
            {
                label: "Direct negotiation with the dealer"
            },
            {
                label: "Cash, bank transfer or combination of both"
            },
            {
                label: "Dealer manages paperwork and car pickup"
            }
        ],
        image: BannerDealer
    }
];
